import { MessageCircle } from "lucide-react";

export const WHATSAPP_NUMBER = "33671351550";
export const WHATSAPP_DISPLAY = "06 71 35 15 50";
const DEFAULT_MESSAGE =
  "Bonjour, je vous contacte au sujet d'une demande d'événement.";

export function buildWhatsAppUrl(message: string = DEFAULT_MESSAGE) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

interface WhatsAppLinkProps {
  message?: string;
  className?: string;
  children?: React.ReactNode;
  iconSize?: number;
  showLabel?: boolean;
  ariaLabel?: string;
}

/**
 * Lien standard "Contacter sur WhatsApp" — ouvre wa.me dans un nouvel onglet.
 */
export const WhatsAppLink = ({
  message,
  className,
  children,
  iconSize = 16,
  showLabel = true,
  ariaLabel = "Contacter sur WhatsApp",
}: WhatsAppLinkProps) => (
  <a
    href={buildWhatsAppUrl(message)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={ariaLabel}
    className={className}
  >
    {children ?? (
      <>
        <MessageCircle size={iconSize} strokeWidth={1.5} />
        {showLabel && <span>WhatsApp</span>}
      </>
    )}
  </a>
);

export default WhatsAppLink;
